export const initialState = {
	actionPlanMessage: undefined,
	isNotificationExpanded: true
};

export default initialState;
